import { getHasMoreColours } from "./getHasMoreColours";

export const mapBadgeType = product => {
  if (
    product.productType === "MixMatchGroup" ||
    product.productType === "MixMatchProduct"
  ) {
    return "MixMatch";
  } else if (
    product.hasVariantColours ||
    getHasMoreColours({ facetGroupings: product.facetGroupings })
  ) {
    return "MoreColors";
  }

  return null;
};
